import { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";
import { FaSearch } from "react-icons/fa";
import Image from "next/image";
import Link from "next/link";

//local imports
import classes from "@/styles/partner/fulfilment.module.css";
import fulfillmentPartners from "@/data/fulfillment-partner.json";
import { fulfillment } from "@/utils/content";
import { countries } from "@/utils/types";
import { useIsMobile } from "@/hooks/useIsMobile";

export default function FulfilmentPartner() {
  const content = fulfillment.en;
  const isMobile = useIsMobile();

  const [tp, setTp] = useState(fulfillmentPartners);

  const [search, setSearch] = useState("");

  const [selectedCountries, setSelectedCountries] = useState<string[]>([]);

  //scroll position
  const [scrollPoint, setScrollPoint] = useState(0);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScrollPoint(window.scrollY);
    });
  });

  const onCountryChange = (value: string) => {
    const found = selectedCountries.find((c) => c === value);
    !found
      ? setSelectedCountries((p) => [...p, value])
      : setSelectedCountries((p) => [...p.filter((l) => l !== value)]);
  };

  const filterChange = () => {
    const tp1 =
      selectedCountries.length !== 0
        ? fulfillmentPartners.filter((t) =>
            t.countries.some((c) => selectedCountries.includes(c))
          )
        : fulfillmentPartners;
    setTp(tp1);
  };

  const searchInput = (e: any) => {
    const text = e.target.value.split(" ");
    setTp(fulfillmentPartners);
    if (e.target.value.length === 0) {
      setSearch("");
      filterChange();
    } else {
      setSearch(e.target.value);
      const newTp = tp.filter((i) => {
        return text.every((el: any) => {
          return i.name.toLowerCase().includes(el);
        });
      });
      setTp(newTp);
    }
  };

  useEffect(() => {
    filterChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountries]);

  return (
    <div className={classes.container}>
      <div className={classes.hero}>
        <h1 className={classes.heading}>{content.title}</h1>
        <p className={classes.para}>{content.subTitle}</p>
        <InputGroup className={classes.inputGroup}>
          <Input
            className={classes.input}
            type="search"
            placeholder={content.searchInputPlaceholder}
            onChange={searchInput}
            value={search}
          />
          <InputGroupText className={classes.inputGroupText}>
            <FaSearch />
          </InputGroupText>
        </InputGroup>
      </div>
      <div className={classes.main}>
        <Container>
          <Row>
            <Col xs={12} lg={2}>
              <Card
                className={
                  isMobile
                    ? classes.card
                    : scrollPoint >= 295
                    ? classes.cardFixed
                    : classes.card
                }
              >
                <div className={classes.cardBody}>
                  <h5>{content.countries}</h5>
                  {countries.map((c) => (
                    <FormGroup key={c.name} check>
                      <Input
                        className={classes.checkBox}
                        type="checkbox"
                        defaultChecked={c.defaultValue}
                        onChange={() => onCountryChange(c.name)}
                      />{" "}
                      <Label className={classes.label} check>
                        {c.label}
                      </Label>
                    </FormGroup>
                  ))}
                </div>
              </Card>
            </Col>
            <Col xs={12} lg={10}>
              <h2 className={classes.heading2}>{content.featured}</h2>
              <Row className="mt-4">
                {tp.map((t) => {
                  if (t.isFeatured) {
                    return (
                      <Col xs={12} lg={6} key={t.name}>
                        <Link
                          className={classes.wrapperLink}
                          href={`/partners${t.url}`}
                        >
                          <Card className={classes.featureCard}>
                            <Row className="align-items-center">
                              <Col xs={12} lg={5} className="border-end pe-0">
                                <Image
                                  className={classes.cardImg}
                                  src={t.logoPath}
                                  alt={t.name}
                                  height={150}
                                  width={250}
                                />
                              </Col>
                              <Col xs={12} lg={7}>
                                <CardBody className={classes.cardBody}>
                                  <h6 className="fw-bold">{t.name}</h6>
                                  <p>{t.desc}</p>
                                </CardBody>
                              </Col>
                            </Row>
                          </Card>
                        </Link>
                      </Col>
                    );
                  }
                })}
              </Row>
              <h2 className={classes.heading2}>{content.comingsoon}</h2>
              <Row className="mt-4">
                {tp.map((t) => {
                  if (t.comingSoon) {
                    return (
                      <Col lg={6} xs={12} key={t.name}>
                        {/* <Link
                          className={classes.wrapperLink}
                          href={`/partners${t.url}`}
                        > */}
                        <Card className={classes.featureCard}>
                          <Row>
                            <Col xs={12} lg={5} className="border-end pe-0">
                              <Image
                                className={classes.cardImg}
                                src={t.logoPath}
                                alt={t.name}
                                height={150}
                                width={250}
                              />
                            </Col>
                            <Col xs={12} lg={7}>
                              <CardBody className={classes.cardBody}>
                                <h6 className="fw-bold">{t.name}</h6>
                                <p>{t.desc}</p>
                              </CardBody>
                            </Col>
                          </Row>
                        </Card>
                        {/* </Link> */}
                      </Col>
                    );
                  }
                })}
              </Row>
            </Col>
          </Row>
        </Container>
        <div className={classes.footer}>
          <Container>
            <p>
              {content.footer1}{" "}
              <a href={`mailto:${content.footerEmail}`}>
                {content.footerEmail}
              </a>
            </p>
            <p>
              {content.footer2}&nbsp;
              <Link href={content.footerLink}>{content.here}</Link>
            </p>
          </Container>
        </div>
      </div>
    </div>
  );
}
